import React from 'react'
import Translations from '@helpers/translations'
import styles from './styles.module.scss'

type SizeChartNavProps = {
  productCategory: string
  setProductCategory: (category: string) => void
  isOpen: boolean
  options: string[]
}

function SizeChartNav({
  productCategory,
  setProductCategory,
  isOpen,
  options
}: SizeChartNavProps) {
  return (
    <div className={styles.sizeChart__nav} data-open={`${isOpen}`}>
      {options.map(option => (
        <button
          key={option}
          type="button"
          className={styles.sizeChart__button}
          data-selected={productCategory === option ? 'true' : 'false'}
          onClick={() => setProductCategory(option)}
        >
          {Translations.localise(`pages.size-chart.${option}`)}
        </button>
      ))}
    </div>
  )
}

export default SizeChartNav
